var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSoonBgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 918,
    height: 976,
    viewBox: "0 0 918 976",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -439,
    y: 0,
    width: 1246,
    height: 943
  }, /*#__PURE__*/React.createElement("rect", {
    x: -439,
    width: 1246,
    height: 943,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-628.872 583.117L153.995 1039.9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M154 138.247L-628.867 595.034",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-574.378 551.322L208.49 1008.1",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M208.49 170.042L-574.378 626.824",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-519.889 519.526L262.979 976.314",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M262.984 201.838L-519.889 658.62",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-465.399 487.736L317.468 944.518",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M317.473 233.628L-465.399 690.416",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-410.909 455.94L371.963 912.723",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M371.963 265.424L-410.904 722.206",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-356.415 424.145L426.452 880.932",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M426.452 297.219L-356.415 754.001",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-301.926 392.354L480.942 849.137",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M480.947 329.01L-301.926 785.797",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-247.437 360.559L535.436 817.341",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M535.436 360.805L-247.432 817.588",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-192.947 328.763L589.925 785.551",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M589.925 392.601L-192.942 849.383",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-138.457 296.973L644.415 753.755",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M644.415 424.391L-138.452 881.179",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-83.9629 265.177L698.905 721.96",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M698.909 456.187L-83.958 912.969",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-29.4736 233.382L753.399 690.169",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M753.399 487.982L-29.4688 944.765",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M25.0156 201.591L807.888 658.374",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M807.888 519.773L25.0205 976.56",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M79.5049 169.795L862.377 626.578",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M862.377 551.568L79.5098 1008.35",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M133.999 138L916.866 594.788",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M916.872 583.364L134.005 1040.15",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoonBgGrid);
export default __webpack_public_path__ + "static/media/img-soon-bg-grid.507433b0fd64b7735d4aa7ebb9f40966.svg";
export { ForwardRef as ReactComponent };